import { render, staticRenderFns } from "./Sorting.vue?vue&type=template&id=711d1862"
import script from "./Sorting.vue?vue&type=script&lang=ts"
export * from "./Sorting.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports